<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5l10-10l-10-10l-10,10L0.5,802.5z M0.5,784.98l7.52,7.52l-7.52,7.52l-7.52-7.52L0.5,784.98z M0.5,797.76
	l-0.88-0.88v-8.76l0.88-0.87l0.87,0.87v8.76L0.5,797.76z M5.75,792.5l-0.87,0.88h-8.76l-0.88-0.88l0.88-0.87h8.76L5.75,792.5z"/>
</svg>

</template>